export default __webpack_public_path__ + "static/media/python.9431343c.png";